var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { ActivatedRoute, Router } from '@angular/router';
var ResetPasswordComponent = /** @class */ (function () {
    function ResetPasswordComponent(util, api, Route, router) {
        this.util = util;
        this.api = api;
        this.Route = Route;
        this.router = router;
        this.submitted = false;
        this.newPass = "";
        this.confirmPass = "";
        this.validToken = false;
    }
    ResetPasswordComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var thisTs_1, _a, thisTs_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.Route.queryParams.subscribe(function (Params) {
                            _this.TokenID = Params["id"];
                        });
                        this.util.ShowWaiting(true);
                        if (!(this.TokenID == null || this.TokenID == "")) return [3 /*break*/, 1];
                        $("#btnMainConfirm").off('click');
                        thisTs_1 = this;
                        $("#btnMainError").click(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    thisTs_1.router.navigate(["/mainmenu/index"]);
                                    return [2 /*return*/];
                                });
                            });
                        });
                        this.util.ErrorDialog("Invalid token.");
                        $("#btnSave").attr("disabled", "disabled");
                        return [3 /*break*/, 3];
                    case 1:
                        _a = this;
                        return [4 /*yield*/, this.GetToken()];
                    case 2:
                        _a.Token = _b.sent();
                        if (this.Token == null || this.Token.trim() == "") {
                            $("#btnMainConfirm").off('click');
                            thisTs_2 = this;
                            $("#btnMainError").click(function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        thisTs_2.router.navigate(["/mainmenu/index"]);
                                        return [2 /*return*/];
                                    });
                                });
                            });
                            this.util.ErrorDialog("Invalid token.");
                            $("#btnSave").attr("disabled", "disabled");
                        }
                        else {
                            this.validToken = true;
                            //this.DeleteToken(this.TokenID);
                        }
                        _b.label = 3;
                    case 3:
                        this.util.ShowWaiting(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.resetPassword = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ParamObj, thisTs_3, Res, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submitted = true;
                        if (!(this.newPass.length > 0 && this.newPass == this.confirmPass && this.validToken
                            && this.passwordValidation())) return [3 /*break*/, 5];
                        this.util.ShowWaiting(true);
                        ParamObj = {
                            //username: (this.Token != null && this.Token.username != null) ? this.Token.username : '',
                            newpassword: this.newPass,
                            token_id: this.Token
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        thisTs_3 = this;
                        return [4 /*yield*/, this.api.postCustomApi("user", "resetpassword", ParamObj)];
                    case 2:
                        Res = _a.sent();
                        //let tmp :any = await this.util.AesDecryptDictValue(Res.json())
                        if (Res.code == "200") {
                            this.util.ShowWaiting(false);
                            this.util.SuccessDialog("เปลี่ยนรหัสผ่านสำเร็จ");
                            $('#btnSuccessOK').on('click', function () {
                                thisTs_3.router.navigate(["mainmenu/login"]);
                            });
                        }
                        else {
                            this.util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        this.util.WarningDialog("เปลี่ยนรหัสผ่านไม่สำเร็จ");
                        return [3 /*break*/, 4];
                    case 4:
                        this.util.ShowWaiting(false);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.GetToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var Res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.getCustomAPI("User", "GetToken", "token_id=" + this.TokenID)];
                    case 1:
                        Res = _a.sent();
                        if (Res != null) {
                            return [2 /*return*/, Res.token_id];
                        }
                        return [2 /*return*/, Res];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.DeleteToken = function (TokenID) {
        return __awaiter(this, void 0, void 0, function () {
            var ParamObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ParamObj = {
                            token_id: TokenID
                        };
                        return [4 /*yield*/, this.api.postCustomApi("user", "deletetoken", ParamObj)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ResetPasswordComponent.prototype.passwordValidation = function () {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/.test(this.newPass);
    };
    return ResetPasswordComponent;
}());
export { ResetPasswordComponent };



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts.pre-build-optimizer.js